export default __webpack_public_path__ + "static/multi-dark-0ccba8a42fe123baba444d9d3f8e329d.png";